module.exports = __webpack_public_path__ + "static/media/img-10.76dd69e5.jpg";